import React, { useEffect, useState } from "react";
import generalHelper from "../utils/generalHelper.js";
import Button from "../customComponents/Button";

import styles from "../../assets/stylesheets/sass/Screen.module.scss";
import { ReactSession }  from 'react-client-session';
import image_error from "./svg/error-sign.svg";
// import Inputfield from './Input';

export default function FormError({transition = false, image = true, titleVisible = true, tryAgain, error}){

	let transitionClasses = {
		[styles.form_section_up]: true,
		[styles.form_section_scaleUp]: false
	};
	const transitionClassesParsed = generalHelper.classNames(transitionClasses);
	const [transClasses, setTransClasses] = useState(transitionClassesParsed);

	const [content_state, setcontent_state] = useState({});
	useEffect(()=>{
		const fetchData = async () =>{
           const data = await fetch(process.env.REACT_APP_SERVER_LINK+"content");
           let res = await data.json();
           setcontent_state(res);
        }
        fetchData();
	}, [])

	const translateError = (error) =>{
		switch (error.errorcode) {
			case 100:
				return ("Gelieve geen velden leeg te laten")
			case 101:
				return (content_state[ReactSession.get("language")] && content_state[ReactSession.get("language")].FormError ? (content_state[ReactSession.get("language")].FormError.error_usernotfound ? content_state[ReactSession.get("language")].FormError.error_usernotfound :  "This user was not found.") : "This user was not found.")
			case 102:
				return ("Deze gebruiker is nog niet geverifieerd")
			case 103:
				return ("Teveel mislukte inlogpogingen, probeer binnen 10 minuten nog eens.")
			case 104:
				return (content_state[ReactSession.get("language")] && content_state[ReactSession.get("language")].FormError ? (content_state[ReactSession.get("language")].FormError.error_passwordincorrect ? content_state[ReactSession.get("language")].FormError.error_passwordincorrect :  "The password is incorrect.") : "The password is incorrect.")
			case 401:
				return (content_state[ReactSession.get("language")] && content_state[ReactSession.get("language")].FormError ? (content_state[ReactSession.get("language")].FormError.error_emptyemail ? content_state[ReactSession.get("language")].FormError.error_emptyemail :  "Please enter your email address.") : "Please enter your email address.")
			case 404:
				return (content_state[ReactSession.get("language")] && content_state[ReactSession.get("language")].FormError ? (content_state[ReactSession.get("language")].FormError.error_usernotfound ? content_state[ReactSession.get("language")].FormError.error_usernotfound :  "This user was not found.") : "This user was not found.");
			default:
				return (content_state[ReactSession.get("language")] && content_state[ReactSession.get("language")].FormError ? (content_state[ReactSession.get("language")].FormError.error_other ? content_state[ReactSession.get("language")].FormError.error_other :  "Something unknown went wrong.") : "Something unknown went wrong.")
		}
	}

	useEffect(()=>{
		if( transition ){
			let transitionClasses = {
				[styles.form_section_up]: true,
				[styles.form_section_scaleUp]: true
			};
			const transitionClassesParsed = generalHelper.classNames(transitionClasses);

			setTransClasses(transitionClassesParsed);
		}
	}, [])

	return (
	    <div className={transClasses} style={{display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center"}}>
	    	<div className={styles.error_image}><img src={image_error} alt="error icon"/></div>
	    	{titleVisible ? 
			<header>
				<h1 className={styles.form_header}>{content_state[ReactSession.get("language")] && content_state[ReactSession.get("language")].FormError ? (content_state[ReactSession.get("language")].FormError.header ? content_state[ReactSession.get("language")].FormError.header :  "Something went wrong...") : "Something went wrong..."}</h1>
				<p className={styles.error_message}>{translateError(error)}</p>
			</header>
			
			 : <></>}
			
			<div style={{marginTop:"2rem"}}><Button value={content_state[ReactSession.get("language")] && content_state[ReactSession.get("language")].FormError ? (content_state[ReactSession.get("language")].FormError.tryagain_button ? content_state[ReactSession.get("language")].FormError.tryagain_button :  "Try again") : "Try again"} onClick={(()=>tryAgain())}/></div>
	    </div>  
  	);
}